<template>
  <div class="login-container">
    <div class="card">
      <h2 class="title">Login</h2>

      <form @submit.prevent="submitForm" class="form">
        <v-text-field
          v-model="username"
          label="Username"
          required
          outlined
          class="input white--text"
        ></v-text-field>
        <v-text-field
          v-model="password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          label="Password"
          required
          outlined
          @click:append="showPassword = !showPassword"
          class="input white--text"
        ></v-text-field>
        <div>
          <button type="submit" class="button" :disabled="loading">
            {{ loading ? "Logging in..." : "Login" }}
          </button>
        </div>
        <p v-if="error" class="errors">{{ error }}</p>
      </form>
    </div>
  </div>
</template>

<script>
import { login, getCurrentUser } from "../auth";
import { loadBrandConfigs } from "../services/brandConfigService";

export default {
  data() {
    return {
      username: "",
      password: "",
      error: "",
      showPassword: false,
      loading: false,
    };
  },
  created() {
    if (getCurrentUser()) {
      this.$router.push("/dashboard");
    }
  },
  methods: {
    async submitForm() {
      if (this.username === "" || this.password === "") {
        this.error = "Please enter username and password.";
        return;
      }
      this.error = "";
      this.loading = true;
      try {
        await login(this.username, this.password);
        await loadBrandConfigs();
        this.$router.push("/dashboard");
      } catch (err) {
        this.error = err.message || "Invalid Login. Please try again.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  overflow: hidden, auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 70px;
  height: 100%;
  background: #FFFFFF;
}

.card {
  width: 40%;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  background-color: white;
  padding: 16px;
  text-align: center;
  margin: 12px;
}

.title {
  font-size: 24px;
  margin-bottom: 16px;
  color: #333;
}

.form {
  display: flex;
  flex-direction: column;
}

.password-input {
  position: relative;
}

.password {
  padding-right: 30px;
}

.button {
  width: 100%;
  height: 40px;
  background-color: #7d60f0;
  border: none;
  border-radius: 20px;
  color: white;
  font-weight: bold;
  cursor: pointer;
}

.errors {
  color: #ff3c00;
  margin: 4px;
  background-color: none !important;
}

@media (max-width: 767px) {
  .card {
    width: 100%;
  }
}

/* Remove browser autofill background */
.input :deep(input:-webkit-autofill),
.input :deep(input:-webkit-autofill:hover),
.input :deep(input:-webkit-autofill:focus) {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  box-shadow: 0 0 0px 1000px white inset;
  -webkit-text-fill-color: #333;
  transition: background-color 5000s ease-in-out 0s;
}
</style>
